"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailTemplates = void 0;
var EmailTemplates;
(function (EmailTemplates) {
    EmailTemplates["NotifySampleReady"] = "NotifySampleReady";
    EmailTemplates["NotifyConsortiumSampleUpload"] = "NotifyConsortiumSampleUpload";
    EmailTemplates["NotifySampleUpload"] = "NotifySampleUpload";
    EmailTemplates["NotifySampleChange"] = "NotifySampleChange";
    EmailTemplates["NotifySampleChangeCentre"] = "NotifySampleChangeCentre";
    EmailTemplates["NotifyComponentSubmitted"] = "NotifyComponentSubmitted";
    EmailTemplates["NotifyMarksApprovalRequest"] = "NotifyMarksApprovalRequest";
    EmailTemplates["NotifyAboutSubmittedMarks"] = "NotifyAboutSubmittedMarks";
    EmailTemplates["NotifyAboutSamplesToSendOffSystem"] = "NotifyAboutSamplesToSendOffSystem";
    EmailTemplates["NotifyAboutSamplesToSendOffSystemOCR"] = "NotifyAboutSamplesToSendOffSystemOCR";
    EmailTemplates["NotifyReplacementWorkSubmitted"] = "NotifyReplacementWorkSubmitted";
})(EmailTemplates = exports.EmailTemplates || (exports.EmailTemplates = {}));
